/* theme.ts */
import { modalAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseModalStyle = definePartsStyle({
  overlay: {
    bg: "rgba(219, 222, 229, 0.6) !important",
  },
  dialog: {
    borderRadius: "20px",
    backdropFilter: "blur(8px) !important",
    boxShadow:
      "0px 12px 24px 6px rgba(129, 139, 165, 0.08), 0px 16px 32px 12px rgba(219, 222, 229, 0.08)",
  },
});

const modalTheme = defineMultiStyleConfig({
  baseStyle: baseModalStyle,
});

export default modalTheme;
